import React from "react";
import "./ConnectCutomerServices.css";
import InnovativeWebsite from "./InnovativeWebsite";

const ConnectCutomerServices = () => {
  return (
    <div className="container container-fluid" id="connect_customer_section">
      <div className="row">
        <div className="col-xxl-8 col-xl-7 col-lg-6 col-md-7 col-sm-12">
          <h2 className="connect-h2">Explore with us</h2>
          <p className="sub-header"> Explore the era of emerging technology!</p>
          <p className="connect-p">
            We offer, Leverage agile frameworks to provide a robust synopsis for
            high level overviews. Iterative approaches to corporate strategy
            foster collaborative thinking to further the overall value
            proposition. It encompasses a wide range of technologies and
            applications, including everything from mobile apps and cloud
            computing to big data analytics and artificial intelligence. This
            industry is playing a critical role in driving innovation and growth
            across a wide range of industries, from healthcare and finance to
            transportation and retail. The software technology industry is also
            responsible for creating a variety of new jobs and career
            opportunities, from software developers and data scientists to
            project managers and business analysts. As the world becomes
            increasingly digital, the software technology industry will continue
            to play a vital role in driving economic growth and shaping the way
            we live and work.
          </p>
        </div>
        <div className="col-xxl-4 col-xl-5 col-lg-6 col-md-5 col-sm-12 CC-Video-div">
          <iframe
            width="560"
            className="CC-Video"
            height="315"
            src="https://www.youtube.com/embed/0JUqp8ev7AI"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ConnectCutomerServices;
